import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function ProtectedRoute({ children, roles }) {
    const { isAuthenticated, user, loading } = useAuth();

    // Wait for auth initialization to finish before deciding
    if (loading) return null;

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (roles && roles.length > 0 && !roles.includes(user?.user_type)) {
        // If user is authenticated but doesn't have the required role, redirect to dashboard
        return <Navigate to="/dashboard" replace />;
    }

    return children;
}

export default ProtectedRoute;
